import moment from 'moment-timezone';

export default selectedDay =>
  ({ from_date }) =>
    moment(from_date).isSame(selectedDay.date, 'day');
